import { Link } from 'react-router-dom';
import { Card } from '@/components/ui/Card';
import { Badge } from '@/components/ui/Badge';
import { formatCOP, formatRate } from '@/lib/format';
import { DEBT_STATUS_LABELS, DEBT_TYPE_LABELS } from '@shared/labels';
import type { DebtDTO } from '@shared/types';

export function DebtCard({ debt }: { debt: DebtDTO }) {
  const progress = debt.principal > 0 ? Math.max(0, Math.min(1, 1 - debt.currentBalance / debt.principal)) : 0;

  return (
    <Link to={`/deudas/${debt.id}`}>
      <Card className="transition-shadow hover:shadow-md">
        <div className="flex items-start justify-between gap-2">
          <div className="min-w-0">
            <p className="truncate font-medium">{debt.name}</p>
            {debt.creditor && <p className="truncate text-xs text-muted-foreground">{debt.creditor}</p>}
          </div>
          <Badge className="shrink-0" tone={debt.status === 'ACTIVE' ? 'debt' : 'muted'}>
            {DEBT_STATUS_LABELS[debt.status]}
          </Badge>
        </div>

        <p className="mt-3 text-2xl font-semibold text-debt">{formatCOP(debt.currentBalance)}</p>
        <p className="text-xs text-muted-foreground">
          {DEBT_TYPE_LABELS[debt.type]} · {formatRate(debt.interestRate)} {debt.interestRateType}
        </p>

        <div className="mt-3 h-2 w-full overflow-hidden rounded-full bg-muted">
          <div className="h-full rounded-full bg-debt" style={{ width: `${Math.round(progress * 100)}%` }} />
        </div>
        <div className="mt-1 flex flex-wrap justify-between gap-x-2 text-xs text-muted-foreground">
          <span>{Math.round(progress * 100)}% pagado</span>
          <span>Interés/mes: {formatCOP(debt.monthlyInterest)}</span>
        </div>
        {(debt.creditLimit != null || debt.minimumPayment != null) && (
          <div className="mt-1 flex flex-wrap justify-between gap-x-2 text-xs text-muted-foreground">
            {debt.creditLimit != null && <span>Cupo usado: {Math.round((debt.currentBalance / debt.creditLimit) * 100)}%</span>}
            {debt.minimumPayment != null && <span>Mínimo: {formatCOP(debt.minimumPayment)}</span>}
          </div>
        )}
      </Card>
    </Link>
  );
}
